import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { CommonMistakes } from './components/CommonMistakes';
import { SolutionSection } from './components/SolutionSection';
import { TomosList } from './components/TomosList';
import { BonusSection } from './components/BonusSection';
import { TargetAudience } from './components/TargetAudience';
import { Testimonials } from './components/Testimonials';
import { PricingSection } from './components/PricingSection';
import { FAQ } from './components/FAQ';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  return <div className="min-h-screen bg-zinc-950 text-zinc-50 font-sans selection:bg-amber-500/30" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <CommonMistakes data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <TomosList data-id="element-5" />
      <BonusSection data-id="element-6" />
      <TargetAudience data-id="element-7" />
      <Testimonials data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FAQ data-id="element-10" />
      <Guarantee data-id="element-11" />
      <Footer data-id="element-12" />

      {/* Overlays */}
      <SocialProofPopup data-id="element-13" />
      <FloatingCTA data-id="element-14" />
    </div>;
}